import React, { useState, useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
    useLocation
} from "react-router-dom";
import Home from './components/home/home';
import Waitlist from './components/waitlist/waitlist';
import Login from './components/login/login';
import Register from './components/login/register';
import Banner from './components/banner/banner';
import Footer from './components/footer/footer';
import AppState from './model/AppState';
import ActionBar from './components/actionBar/actionBar';
import Notification from './components/notification/notification';
import InDepthBetCard from './components/betFeed/inDepthBetCard';
import eventBus from './service/eventBus';
import PasswordResetConfirm from './components/passwordReset/passwordResetConfirm';
import { EVENT_TRIGGER_IN_DEPTH_BET_CARD } from './utils/constants';
import ReportsActivityWrapper from './components/activityReport/ReportsActivityWrapper';
import CheckoutResult from './components/billing/checkoutResult';
import AdminPageWrapper from './components/admin/AdminPageWrapper';

// Renders routes and conditionally the action bar (hidden on admin/report routes)
const AppRoutesWithBar = () => {
    const location = useLocation();
    const hideActionBar = location.pathname.startsWith('/admin') || location.pathname === '/reports/activity' || location.pathname === '/billing/checkout-result';
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/admin" element={<AdminPageWrapper />} />
                <Route path="/reports/activity" element={<ReportsActivityWrapper />} />
                <Route path="/billing/checkout-result" element={<CheckoutResult />} />
                <Route path="/reset-password/:token?" element={<PasswordResetConfirm />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
            </Routes>
            {!hideActionBar && <ActionBar />}
        </>
    );
};

function App() {
    const componentId = 'App';
    const [showWaitlistOnly, setShowWaitlistOnly] = useState(false);
    const [isBetDataCardOpen, setIsBetDataCardOpen] = useState(false);

    const adjustBodyHeight = () => {
        console.log('adjusting body height');
        const windowInnerHeight = window.innerHeight;
        document.body.style.height = `${windowInnerHeight}px`;
    }
    
    useEffect(() => {
        eventBus.on(componentId, EVENT_TRIGGER_IN_DEPTH_BET_CARD, (isOpen) => {
            console.log(`Event ${EVENT_TRIGGER_IN_DEPTH_BET_CARD} received with value`, isOpen);
            setIsBetDataCardOpen(isOpen);
        });

        // adjustBodyHeight();
        // window.addEventListener('resize', adjustBodyHeight);
        return () => {
            eventBus.off(componentId, EVENT_TRIGGER_IN_DEPTH_BET_CARD);
            window.removeEventListener('resize', adjustBodyHeight);
        };
    }, []);

    return (
        <div className={'App'} style={{ overflow: ( isBetDataCardOpen ? 'hidden' : 'auto') }}>
            <Notification />
            <Router>
                <Banner />
                {showWaitlistOnly ? (
                    <Routes>
                        <Route path="/waitlist" element={<Waitlist />} />
                        <Route path="*" element={<Navigate to="/waitlist" replace />} />
                    </Routes>
                ) : (
                    <AppRoutesWithBar />
                )}
            </Router>
            <Notification/>
        </div>
    );
}

export default App;
